// Author lidongxu
// Date 2023-12-04 15:15:22

class SithMesInventoryComprehensiveBusinessDetail {
    constructor({
                    id = null,
                    businessApplicationNo = '',
                    projectCode = '',
                    projectName = '',
                    wbs = '',
                    orderCode = '',
                    prCode = '',
                    remark = ''
                }
                        = {}) {
        this.id = id;
        this.businessApplicationNo = businessApplicationNo;
        this.projectCode = projectCode;
        this.projectName = projectName;
        this.wbs = wbs;
        this.orderCode = orderCode;
        this.prCode = prCode;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesInventoryComprehensiveBusinessDetail();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'businessApplicationNo',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.grid.businessApplicationNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbs',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.grid.wbs',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prCode',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.grid.prCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    businessApplicationNoFilter: '',
    businessApplicationNoListFilter: [],
    projectCodeFilter: '',
    projectNameFilter: '',
    wbsFilter: '',
    orderCodeFilter: '',
    prCodeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'businessApplicationNoFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.filter.businessApplicationNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.filter.wbs',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.filter.prCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'businessApplicationNo',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.entity.businessApplicationNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.entity.projectName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbs',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.entity.wbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.entity.orderCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prCode',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.entity.prCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesInventoryComprehensiveBusinessDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
